import { supabase } from '@/lib/supabase';
import type { LevelInfo } from '@/components/ui/LevelBadge';

export async function getUserLevel(userId?: string): Promise<LevelInfo> {
  const { data, error } = await supabase.rpc('get_user_level', userId ? { p_user_id: userId } : {});
  if (error) throw error;
  return data as LevelInfo;
}
